import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import useDefinedSentryUser from './hooks/useDefinedSentryUser'
import useFcmToken from './hooks/useFcmToken'
import AuthLayout from './layouts/AuthLayout'
import RootLayout from './layouts/RootLayout'
import APIUsageTemplateModule from './modules/APIUsageTemplate'
import AuthModule from './modules/Auth'
import { BusinessModule, HRMBusinessModule } from './modules/Business'
import ContractModule from './modules/Contract'
import CustomerModule from './modules/Customer'
import DashboardModule from './modules/Dashboard'
import {
    DayOffEmployeeModule,
    DayOffHrmModule,
    DayOffModule,
} from './modules/Dayoffs'
import { OncallAdminModule } from './modules/Oncall'
import DocumentModule from './modules/Documents'
import EmployeeModule from './modules/Employee'
import HolidayModule from './modules/Holiday'
import InvoiceModule from './modules/Invoice'
import JobCategoryModule from './modules/JobCategory'
import JobModule from './modules/Jobs'
import KPIModule from './modules/KPI'
import MarketingModule from './modules/Marketing'
import NotFoundModule from './modules/NotFound'
import ReleaseNotesModule from './modules/ReleaseNotes'
import ReportModule from './modules/Report'

import ResumeModule from './modules/Resume'
import RolesModule from './modules/Roles'
import ServiceModule from './modules/Service'
import TicketModule, { TicketFeedbackPublic } from './modules/Ticket'
import UtilModule from './modules/Util'
import { VCard, VCardPublic } from './modules/VCard'
import { AccountWorkDayModule, WorkDayModule } from './modules/WorkDay'
import AccountModule from './modules/Account'
import DriveModule from './modules/Drive'
import SettingsModule from './modules/Settings'
import TendersModule from './modules/Tenders'
import SurveyModule from './modules/Survey'
import MailerCampaignModule from './modules/MailerCampaign'
import WarehouseModule from './modules/Warehouse'
import LivechatModule from './modules/Livechat'
import ResellerModule from './modules/Reseller'
import AffiliateModule from './modules/Affiliate'
import PromoModule from './modules/Promo'
import TechnicalModule from './modules/Technical'
import TechnicalReportModule from './modules/Technical/Report'
import WatchpointModule from './modules/Technical/Watchpoint'
import ThresholdModule from './modules/Technical/Threshold'
import AssetModule from './modules/Asset'
import ToolsModule from './modules/Tools'

// Router created at module level to prevent recreation on HMR updates
const router = createBrowserRouter([
    {
        path: '/',
        element: <RootLayout />,
        children: [
            DashboardModule,
            NotFoundModule,
            EmployeeModule,
            BusinessModule,
            HRMBusinessModule,
            CustomerModule,
            HolidayModule,
            WorkDayModule,
            AccountWorkDayModule,
            ContractModule,
            DriveModule,
            InvoiceModule,
            TicketModule,
            ServiceModule,
            DocumentModule,
            MarketingModule,
            ReportModule,

            JobModule,
            JobCategoryModule,
            ResumeModule,
            DayOffHrmModule,
            DayOffEmployeeModule,
            DayOffModule,
            OncallAdminModule,
            VCard,
            KPIModule,
            APIUsageTemplateModule,
            RolesModule,
            ReleaseNotesModule,
            AccountModule,
            SettingsModule,
            TendersModule,
            SurveyModule,
            MailerCampaignModule,
            WarehouseModule,
            LivechatModule,
            ResellerModule,
            AffiliateModule,
            PromoModule,
            TechnicalModule,
            WatchpointModule,
            ThresholdModule,
            TechnicalReportModule,
            AssetModule,
            ToolsModule,
        ],
    },
    {
        path: '/auth',
        element: <AuthLayout />,
        children: [AuthModule],
    },
    {
        path: '/util',
        children: [UtilModule],
    },
    // Public pages (no auth required)
    TicketFeedbackPublic,
    VCardPublic,
])

const App = () => {
    useFcmToken()
    useDefinedSentryUser()

    return <RouterProvider router={router} />
}

export default App
